/**
 * Aparencia do workspace: tema e idioma preferidos.
 */
export type Aparencia = {
  acento: number;
  tema: 'escuro' | 'claro';
  idioma: 'pt' | 'en' | 'es';
};
export { tokensDaMarca } from './tokens.ts';

/**
 * A cor do sistema e a da marca TME, fixa em tokens.css. O acento salvo em
 * Configuracoes fica so como preferencia registrada: nao recolore a tela,
 * porque o sistema usa so a identidade da TME.
 */
export function aplicarMarca(_v: Aparencia): void {}
